/**
 * docTitle — ชื่อเอกสารต้องตรงกับข้อมูลที่พิมพ์อยู่บนกระดาษจริง
 *
 * ══════════════════════════════════════════════════════════════
 * 🔴 ห้ามพิมพ์คำว่า "ใบกำกับภาษีอย่างย่อ" ลอย ๆ
 *
 * เดิมพิมพ์ตายตัวทุกใบ เจอจริง 18 ก.ย. 2026: เครื่องที่ยังไม่ตั้งค่า
 * ออกใบที่พาดหัวว่าใบกำกับภาษีอย่างย่อ โดยไม่มีชื่อร้านจริง
 * ไม่มีเลขประจำตัวผู้เสียภาษี และไม่มีบรรทัด VAT เลยสักบรรทัด
 *
 * ใบแบบนั้นร้านที่รับไปใช้อ้างอิงทางภาษีไม่ได้ และคนออกใบก็ไม่รู้ตัว
 * เพราะหน้าจอไม่เคยเตือนอะไร
 *
 * กติกาในไฟล์นี้: เรียกว่าใบกำกับภาษีได้ก็ต่อเมื่อบนใบมีทั้ง
 * เลขประจำตัวผู้เสียภาษีของร้าน และยอด VAT ที่มากกว่าศูนย์
 * ขาดอย่างใดอย่างหนึ่ง -> พิมพ์แค่ "ใบเสร็จรับเงิน" ซึ่งถูกต้องเสมอ
 *
 * ⚠️ นี่เป็นการกันความเข้าใจผิดเบื้องต้นเท่านั้น ไม่ใช่คำแนะนำทางบัญชี
 *    รูปแบบใบกำกับภาษีอย่างย่อที่ถูกต้องครบถ้วน ให้ยืนยันกับผู้ทำบัญชี
 * ══════════════════════════════════════════════════════════════
 */

/** ใบนี้มีข้อมูลครบพอจะเรียกว่าใบกำกับภาษีไหม */
export function isTaxInvoice({ shopTaxId, vatAmount } = {}) {
  const hasTaxId = Boolean(String(shopTaxId || '').trim());
  // ดู vatAmount ไม่ใช่ vatPercent เพราะบางที่ตั้ง default percent ไว้ 7
  // ทั้งที่ใบนั้นไม่ได้คิด VAT จริง
  return hasTaxId && Number(vatAmount) > 0;
}

export function receiptTitle(opts) {
  return isTaxInvoice(opts) ? 'ใบเสร็จรับเงิน / ใบกำกับภาษีอย่างย่อ' : 'ใบเสร็จรับเงิน';
}

export function salesOrderTitle(opts) {
  return isTaxInvoice(opts) ? 'ใบสั่งขาย / ใบกำกับภาษีอย่างย่อ' : 'ใบสั่งขาย';
}
